import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { ClipboardList, Edit, Plus, Search, Trash2, UserPlus } from "lucide-react";

// Form builder and responses.
const FormsTab = ({
  clients,
  deleteForm,
  filteredForms,
  formResponses,
  forms,
  searchForms,
  setAssignData,
  setAssignFormOpen,
  setEditingForm,
  setFormBuilderOpen,
  setNewForm,
  setSearchForms,
  viewFormResponses,
}) => {
  return (
    <div className="forms-view">
      <div className="view-header">
        <h1>Formularze</h1>
        <div style={{display:'flex', gap:'8px', alignItems:'center'}}>
          <div style={{position:'relative'}}>
            <Search size={16} style={{position:'absolute',left:8,top:'50%',transform:'translateY(-50%)',color:'var(--text-secondary)'}} />
            <Input placeholder="Szukaj..." value={searchForms} onChange={e => setSearchForms(e.target.value)} style={{paddingLeft:32,width:200}} />
          </div>
          <Button variant="outline" onClick={() => { setAssignData({ form_id: "", client_id: "", frequency: "once" }); setAssignFormOpen(true); }} disabled={forms.length === 0 || clients.length === 0}>
            <UserPlus size={16} /> Przypisz
          </Button>
          <Button onClick={() => { setEditingForm(null); setNewForm({ name: "", type: "check_in", fields: [] }); setFormBuilderOpen(true); }}>
            <Plus size={18} /> Nowy formularz
          </Button>
        </div>
      </div>

      {filteredForms.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <ClipboardList size={48} strokeWidth={1} />
            <h3>Brak formularzy</h3>
            <p>Stwórz formularze onboardingowe i check-in</p>
          </CardContent>
        </Card>
      ) : (
        <div className="forms-grid">
          {filteredForms.map(form => {
            const responseCount = formResponses.filter(r => r.form_id === form.id).length;
            return (
              <Card key={form.id} className="form-card clickable-card" onClick={() => viewFormResponses(form.id)}>
                <div className="form-card-actions">
                  <Button variant="ghost" size="sm" onClick={(e) => {
                    e.stopPropagation();
                    setEditingForm(form);
                    setNewForm({ name: form.name, type: form.type, fields: form.fields });
                    setFormBuilderOpen(true);
                  }}>
                    <Edit size={14} />
                  </Button>
                  <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); deleteForm(form.id); }}>
                    <Trash2 size={14} />
                  </Button>
                </div>
                <CardContent>
                  <ClipboardList size={24} />
                  <div className="form-details">
                    <h3>{form.name}</h3>
                    <div className="form-meta">
                      <Badge variant={form.type === 'onboarding' ? 'default' : 'secondary'}>
                        {form.type === 'onboarding' ? 'Onboarding' : 'Check-in'}
                      </Badge>
                      <span>{form.fields?.length || 0} pól</span>
                    </div>
                    {responseCount > 0 && <span className="form-response-count">{responseCount} odpowiedzi</span>}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FormsTab;
